// extracted by mini-css-extract-plugin
export var brand = "_4a-9";
export var compact = "_4a-6";
export var extraSmall = "_4a-7";
export var icon = "_4a-0";
export var large = "_4a-4";
export var light = "_4a-1";
export var medium = "_4a-5";
export var outline = "_4a-b";
export var primaryDark = "_4a-a";
export var primaryLight = "_4a-8";
export var primaryModern = "_4a-c";
export var success = "_4a-2";
export var successSolid = "_4a-3";